
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/developer-tools",
      function () {
        return require("private-next-pages/sub/developer-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/developer-tools"])
      });
    }
  